/*
*
* File JS per la Single Magazine
*
*/

// IMPORT COMPONENTI
//--------------------------------------------------------------------//

import heroPage from 'components/hero-page/hero-page';
import anchorMenu from 'components/anchor-menu/anchor-menu';
import schedaStore from 'components/block-scheda-store/block-scheda-store';
import timetablesStore from 'components/block-timetables-store/block-timetables-store';
import mapStore from 'components/block-map-store/block-map-store';
import flyerList from 'components/lists/flyer-list/flyer-list';
import catalogsSlider from 'components/block-catalogs-slider/block-catalogs-slider';
import servicesDepartments from 'components/block-services-departments/block-services-departments';
import blockNews from 'components/block-news/block-news';

//--------------------------------------------------------------------//

// IMPORT STILE SPECIFICO PAGINA
//--------------------------------------------------------------------//

import './single-store.scss';

//--------------------------------------------------------------------//

// INIT COMPONENTI
//--------------------------------------------------------------------//

window.addEventListener('DOMContentLoaded', (evt) =>
{
    anchorMenu();
    mapStore();
    catalogsSlider();
});

//--------------------------------------------------------------------//